/**
 * plugins/vuetify.js
 *
 * Framework documentation: https://vuetifyjs.com`
 */

// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

// Composables
import { createVuetify } from 'vuetify'

// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
export default createVuetify({
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          primary: '#2563EB',    // Confident Sapphire Blue
          success: '#10B981',    // Approval Emerald Green
          error: '#EF4444',      // Cautionary Crimson (Vuetify uses 'error' instead of 'danger')
          accent: '#8B5CF6',     // Accent Amethyst
          info: '#36b9cc',      // Info Teal
          purple: '#6f42c1',    // Purple
          orange: '#fd7e14',    // Orange
          teal: '#20c997',      // Teal
          cyan: '#17a2b8',      // Cyan
          background: '#F8FAFC', // Snow White
          surface: '#FFFFFF',    // Pearl
          'text-primary': '#1E293B',   // Charcoal
          'text-secondary': '#64748B', // Slate
          'border-color': '#E2E8F0',   // Silver Mist
        },
      },
      dark: {
        colors: {
          primary: '#2563EB',    // Confident Sapphire Blue
          success: '#10B981',    // Approval Emerald Green
          error: '#EF4444',      // Cautionary Crimson (Vuetify uses 'error' instead of 'danger')
          accent: '#8B5CF6',     // Accent Amethyst
          info: '#36b9cc',      // Info Teal
          purple: '#6f42c1',    // Purple
          orange: '#fd7e14',    // Orange
          teal: '#20c997',      // Teal
          cyan: '#17a2b8',      // Cyan
          background: '#0F172A', // Midnight Navy
          surface: '#1E293B',    // Deep Ocean
          'text-primary': '#F1F5F9',   // Polar Ice
          'text-secondary': '#94A3B8', // Arctic Blue
          'border-color': '#334155',   // Space Gray
        },
      },
    },
  },
})
